import XLSX from "xlsx";
import { message } from "ant-design-vue";

function doExcel(tableID, filename, ignoreTitles) {
  // 如果未提供文件名，则默认使用当前日期时间作为文件名
  var fname = filename
    ? filename + ".xlsx"
    : "export-" + new Date().toISOString().replace(/[\-\:\.]/g, "") + ".xlsx";

  // 获取指定 ID 的表格元素
  var table = document.getElementById(tableID);

  var source = table;
  // 需排除的列（按列标题），例如导出时不要“操作”列
  if (ignoreTitles && ignoreTitles.length) {
    // 克隆表格，避免改动页面实时渲染的表格
    source = table.cloneNode(true);
    var thead = source.querySelector("thead");
    var headerRow = thead ? thead.querySelector("tr") : null;
    var headerCells = headerRow ? Array.prototype.slice.call(headerRow.children) : [];
    var ignoreIndexes = [];
    headerCells.forEach(function (cell, index) {
      var text = (cell.textContent || "").toString().trim();
      if (ignoreTitles.indexOf(text) > -1) {
        ignoreIndexes.push(index);
      }
    });
    if (ignoreIndexes.length) {
      // 移除表头对应列
      for (var i = ignoreIndexes.length - 1; i > -1; i--) {
        if (headerCells[ignoreIndexes[i]]) {
          headerCells[ignoreIndexes[i]].remove();
        }
      }
      // 移除每一行中对应的单元格
      var rows = source.querySelectorAll("tbody tr");
      for (var r = 0; r < rows.length; r++) {
        var cells = rows[r].children;
        for (var j = ignoreIndexes.length - 1; j > -1; j--) {
          if (cells[ignoreIndexes[j]]) {
            cells[ignoreIndexes[j]].remove();
          }
        }
      }
    }
  }

  // 将 HTML 表格转换为工作表
  var wb = XLSX.utils.table_to_book(source, { sheet: "Sheet1" });

  // 生成 Excel 文件并触发下载
  XLSX.writeFile(wb, fname);
}
export { doExcel };
